export default "__VITE_ASSET__BC1KIaX$__"